import React from 'react'

import IconButton from '@mui/material/IconButton';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

const BackButton =({
    style= 'basic',
    showText = false,
    offsetX = -6,
    offsetY = 0,
    onClick = null,
    size = 'large',
    text = 'Back',
    ...props
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            if (undefined == window.history.back()) {
                window.close()
            } else {
                window.history.back()
            }
        }
    }

    const buttonStyle = {
        display: 'inline-block',
        fontSize: '1.2rem',
    }

    const iconStyle = {
        padding: 0,
        fontSize: 32,
        left: offsetX,
        top: offsetY,
        position: 'relative',
    }

    return (
        <a
            style={buttonStyle}
            className={`back-button`}
            onClick={() => handleClick()} >
            <IconButton variant="outlined" style={iconStyle}>
                <KeyboardArrowLeftIcon fontSize={'32px'} />
                {showText ? text : null}
            </IconButton>
        </a>
    )
}

export default BackButton